import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";

import Grid from "react-bootstrap/lib/Grid";
import Row from "react-bootstrap/lib/Row";
import Col from "react-bootstrap/lib/Col";
import { push, goBack } from "connected-react-router";
import { func, bool, string } from "prop-types";

import { actions as communicationsActions, selectors as communicationsSelector } from "reducers/communications";
import { selectors as communicationSelectors } from "reducers/communication";

import List from "pages/communications/_components/List";
import Head from "pages/_components/Head";
import LeftPanel from "pages/communications/_components/LeftPanel";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import HeaderSimple from "pages/_components/HeaderSimple/HeaderSimple";
import { ResponsiveHeader, DesktopButtons, MobileButtons } from "pages/_components/header";
import Button from "pages/_components/Button";
import Action from "pages/_components/Action";
import Drawer from "pages/_components/Drawer/Drawer";

const CommunicationMain = ({ dispatch, isDesktop, detail, isFetching, leftPanel }) => {
    const [isComposing] = useState(false);
    const { pathname } = useLocation();
    const isOnboarding = pathname === "/environment/communications";

    useEffect(() => {
        dispatch(communicationsActions.listTypesRequest());
        dispatch(communicationsActions.listRequest({ direction: "BANK_TO_CUSTOMER" }));
    }, []);

    const handleComposeClick = (isReply) => {
        if (isDesktop) {
            if (isReply) {
                dispatch(communicationsActions.showReplyPanel());
            } else {
                dispatch(communicationsActions.showComposePanel());
            }
        } else {
            dispatch(push("/communications/compose"));
        }
    };

    const handleComposeCloseClick = () => {
        if (detail) {
            dispatch(communicationsActions.showReadPanel());
        } else {
            dispatch(communicationsActions.hideAllPanels());
        }
    };

    const handleBackClick = () => {
        dispatch(goBack());
    };

    if (isDesktop) {
        return (
            <Fragment>
                <Notification scopeToShow="communications" />
                {isOnboarding && <HeaderSimple className="d-flex justify-content-between" inverse showNotifications />}
                <ResponsiveHeader id="chat.title" showTitle>
                    <>
                        <DesktopButtons>
                            <Button
                                className="btn-outline"
                                onClick={() => handleComposeClick(false)}
                                label="communications.compose.message.new"
                            />
                        </DesktopButtons>
                        <MobileButtons>
                            <Action
                                labelKey="communications.compose.message.new"
                                handleClick={() => handleComposeClick(false)}
                            />
                        </MobileButtons>
                    </>
                </ResponsiveHeader>
                <MainContainer
                    className="main-container administration__signatures-schemes messaging"
                    showLoader={isFetching}>
                    <Grid className="messages-container form-content">
                        <Row className="justify-content-center communications-desktop-cols">
                            <Drawer
                                openSidebar={!!leftPanel}
                                onClose={handleComposeCloseClick}
                                enableCloseButton={false}
                                isFullHeight>
                                <div className="container full-width">
                                    <LeftPanel
                                        compose={isComposing}
                                        close={handleComposeCloseClick}
                                        reply={() => handleComposeClick(true)}
                                        isDesktop={isDesktop}
                                    />
                                </div>
                            </Drawer>
                            <Col className="col-12 col-6">
                                <List isDesktop={isDesktop} handleComposeCloseClick={handleComposeCloseClick} />
                            </Col>
                        </Row>
                    </Grid>
                </MainContainer>
            </Fragment>
        );
    }

    return (
        <Fragment>
            <Notification scopeToShow="communications" />
            <Head
                title="chat.title"
                isComposing={false}
                isDesktop={isDesktop}
                onBack={handleBackClick}
                addLinkTo="/communications/compose"
                showPlusIcon
                showCenterContent
            />
            <MainContainer>
                <div className="above-the-fold mailing">
                    <List isDesktop={isDesktop} />
                </div>
            </MainContainer>
        </Fragment>
    );
};

CommunicationMain.propTypes = {
    dispatch: func.isRequired,
    isDesktop: bool.isRequired,
    detail: bool.isRequired,
    isFetching: bool.isRequired,
    leftPanel: string,
};

CommunicationMain.defaultProps = {
    leftPanel: "",
};

const mapStateToProps = (state) => ({
    types: communicationsSelector.listTypes(state),
    detail: communicationSelectors.detail(state),
    isFetching: communicationsSelector.isFetching(state),
    leftPanel: communicationsSelector.leftPanel(state),
});

export default connect(mapStateToProps)(CommunicationMain);
